import { render, staticRenderFns } from "./RoleManagement_Component.vue?vue&type=template&id=0936baa0&scoped=true&"
import script from "./RoleManagement_Component.vue?vue&type=script&lang=js&"
export * from "./RoleManagement_Component.vue?vue&type=script&lang=js&"
import style0 from "./RoleManagement_Component.vue?vue&type=style&index=0&id=0936baa0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0936baa0",
  null
  
)

export default component.exports